module.exports = __webpack_public_path__ + "img/附子.a7ea6a83.jpg";